<div class="mb-3">
  <div>
    @if (mode === 'registrations') {
      <h1 class="pb-2 border-bottom fw-light" i18n>Registrierung bearbeiten</h1>
    } @else {
      <h1 class="pb-2 border-bottom fw-light" i18n>Benutzer bearbeiten</h1>
    }

    @if (profileForm) {
      <form [formGroup]="profileForm">
        <input type="hidden" formControlName="id" class="form-control form-control-sm" />
        <div class="row">
          <div class="col-sm-6">
            <div class="row mb-2">
              <label class="col-sm-4 col-form-label col-form-label-sm" for="email" i18n>E-Mail</label>
              <div class="col-sm-8">
                <input id="email" type="text" formControlName="email" class="form-control form-control-sm" />
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-sm-4 col-form-label col-form-label-sm" for="fullName" i18n>Name</label>
              <div class="col-sm-8">
                <input id="fullName" type="text" formControlName="fullName" class="form-control form-control-sm" />
              </div>
            </div>
            <app-form-row label="Benutzerrolle" i18n-label>
              <kendo-dropdownlist
                [data]="roles"
                formControlName="role"
                textField="DisplayName"
                valueField="Id"
                [valuePrimitive]="true"
                data-testid="user-edit-role-select"
              ></kendo-dropdownlist>
            </app-form-row>
            <app-form-row label="Status" i18n-label>
              <kendo-dropdownlist
                [data]="states"
                formControlName="status"
                textField="DisplayName"
                valueField="Id"
                [valuePrimitive]="true"
                data-testid="user-edit-status-select"
              ></kendo-dropdownlist>
            </app-form-row>
            @if (isLastAdmin) {
              <p class="form-text" data-testid="user-edit-last-admin-hint" i18n>
                Dies ist der letzte freigegebene Administrator – Rolle und Status lassen sich nicht ändern.
              </p>
            }
          </div>
        </div>

        <button class="btn btn-secondary m-2" type="button" (click)="onBackClicked()" i18n>Zurück</button>
        @if (mode === 'registrations' || profile?.isActive) {
          <button
            class="btn btn-primary m-2"
            type="button"
            [asyncClick]="submitForm.bind(this)"
            [disabled]="saveBtn.disabled || profileForm.invalid || isLastAdmin"
            #saveBtn="asyncClick"
            data-testid="user-edit-save-button"
            i18n
            >
            @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
            Bestätigen
          </button>
        }
      </form>
    }
  </div>
</div>
